import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import CasesCreateBillingDisputeModal from './CasesCreateBillingDisputeModal'
import { createBillingDispute } from 'features/Cases/Cases.actions'
import { get, flow } from 'lodash'

const formName = 'createBillingDispute'

const stateToProps = ({ form, billing }) => ({
  formData: get(form, [formName, 'values'], {}),
  bills: billing.bills,
})

const dispatchToProps = {
  createBillingDispute,
}

export default flow(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(CasesCreateBillingDisputeModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesCreateBillingDisputeModal/CasesCreateBillingDisputeModal.container.js